export default "__VITE_ASSET__0ae756bf__"